var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.22505 7.05806C4.46913 6.81398 4.86486 6.81398 5.10893 7.05806L10.5003 12.4495L15.8917 7.05806C16.1358 6.81398 16.5315 6.81398 16.7756 7.05806C17.0197 7.30214 17.0197 7.69787 16.7756 7.94194L10.9423 13.7753C10.6982 14.0194 10.3025 14.0194 10.0584 13.7753L4.22505 7.94194C3.98097 7.69787 3.98097 7.30214 4.22505 7.05806Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.96318b1a34c72c67114616703a07506e.svg";
export { ForwardRef as ReactComponent };